import { string } from 'yup';

import { containsRestrictedPathChars } from './FileUtils';

export const ItemNameValidation = string()
  .trim()
  .max(255, 'Name cannot be longer than 255 characters')
  .test(
    'restricted-char-validation',
    'Characters : and | cannot be used',
    (val) => !containsRestrictedPathChars(val || ''),
  )
  .matches(/^[^\n]*$/, 'No line breaks allowed')
  .required('Name is required');
